import React from 'react';

interface RadioGroupProps<T extends string | number> {
  selectedValue: T;
  onChange: (value: T) => void;
  options: { label: string; value: T }[];
}

// Generic RadioGroup component
export const RadioGroup = <T extends string | number>({ selectedValue, onChange, options }: RadioGroupProps<T>) => {
  return (
    <div>
      {options.map(option => (
        <label key={option.value}>
          <input
            type="radio"
            name="extendOption"
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};
